module.exports = __webpack_public_path__ + "cd455783/img/saly-icon.39e12342.jpg";